import { __rest, __assign } from 'tslib';
import React, { forwardRef, useState, useCallback, Fragment } from 'react';
import mergeRefs from 'react-merge-refs';
import cn from 'classnames';
import { Portal } from '@alfalab/core-components-portal/esm';

var styles = {"suffixContainer":"with-suffix__suffixContainer_1fkdl","size-40":"with-suffix__size-40_1fkdl","suffixVisible":"with-suffix__suffixVisible_1fkdl","hasSuffix":"with-suffix__hasSuffix_1fkdl","spacer":"with-suffix__spacer_1fkdl","suffix":"with-suffix__suffix_1fkdl","disabled":"with-suffix__disabled_1fkdl","inverted":"with-suffix__inverted_1fkdl","readOnly":"with-suffix__readOnly_1fkdl"};
require('./index.css')

var withSuffix = function (Input) {
    return forwardRef(function (_a, ref) {
        var _b, _c, _d;
        var value = _a.value, defaultValue = _a.defaultValue, onChange = _a.onChange, onClear = _a.onClear, _e = _a.suffix, suffix = _e === void 0 ? '' : _e, placeholder = _a.placeholder, className = _a.className, disabled = _a.disabled, readOnly = _a.readOnly, suffixContainerClassName = _a.suffixContainerClassName, restProps = __rest(_a, ["value", "defaultValue", "onChange", "onClear", "suffix", "placeholder", "className", "disabled", "readOnly", "suffixContainerClassName"]);
        var uncontrolled = value === undefined;
        var _f = useState(null), inputNode = _f[0], setInputNode = _f[1];
        var _g = useState(defaultValue || ''), stateValue = _g[0], setStateValue = _g[1];
        var handleInputChange = useCallback(function (event, payload) {
            if (onChange) {
                onChange(event, payload);
            }
            if (uncontrolled) {
                setStateValue(payload.value);
            }
        }, [onChange, uncontrolled]);
        var handleClear = useCallback(function (event) {
            if (uncontrolled) {
                setStateValue('');
            }
            if (onClear) {
                onClear(event);
            }
        }, [onClear, uncontrolled]);
        var getPortalContainer = useCallback(
        // TODO: Изменить сигнатуру getPortalContainer в Portal
        function () { return ((inputNode === null || inputNode === void 0 ? void 0 : inputNode.parentElement) || null); }, [inputNode]);
        var visibleValue = uncontrolled ? stateValue : value;
        var isInverted = restProps.colors === 'inverted';
        return (React.createElement(Fragment, null,
            React.createElement(Input, __assign({ ref: mergeRefs([ref, setInputNode]), value: visibleValue, disabled: disabled, readOnly: readOnly, onChange: handleInputChange, onClear: handleClear, placeholder: placeholder, className: cn(className, (_b = {},
                    _b[styles.suffixVisible] = Boolean(visibleValue),
                    _b[styles.hasSuffix] = suffix,
                    _b)) }, restProps)),
            React.createElement(Portal, { getPortalContainer: getPortalContainer },
                React.createElement("div", { translate: 'no', className: cn(styles.suffixContainer, suffixContainerClassName, (_c = {},
                        _c[styles["size-".concat(restProps.size)]] = restProps.size,
                        _c)) },
                    React.createElement("span", { className: styles.spacer }, visibleValue),
                    suffix && (React.createElement("div", { className: cn(styles.suffix, (_d = {},
                            _d[styles.disabled] = disabled,
                            _d[styles.readOnly] = readOnly,
                            _d[styles.inverted] = isInverted,
                            _d)) }, suffix))))));
    });
};

export { withSuffix };
